'use client';

import { QueryClient } from '@tanstack/react-query';

// Function to create a new query client with optimized settings
export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Refresh data when window regains focus
        refetchOnWindowFocus: true,
        
        // Refresh data when reconnecting after connection loss
        refetchOnReconnect: true,
        
        // Default stale time (10 seconds)
        staleTime: 10000,
        
        // Default retry configuration
        retry: (failureCount, error) => {
          // Don't retry on 404s or other client errors
          if (error instanceof Error && error.message.includes('404')) {
            return false;
          }
          
          // Don't retry on abort errors (e.g., user navigated away)
          if (error instanceof DOMException && error.name === 'AbortError') {
            return false;
          }
          
          // Otherwise retry up to 3 times
          return failureCount < 3;
        },
        
        // Exponential backoff for retries
        retryDelay: (attemptIndex) => Math.min(1000 * (2 ** attemptIndex), 30000),
      },
    },
  });
}

// Export a singleton QueryClient for client components to use
export const queryClient = createQueryClient(); 